
import { baseApi } from "@store/apis";
import localStorageSecureWrapper from "@utilities/localStorageSecureWrapper";

import type { ChallengeDetails, ChallengeDetailsRequest } from "./models";


const GetChallengeDetailsQuery = baseApi.injectEndpoints({
  endpoints: builder => ({
    GetChallengeDetails: builder.query({
      query: ({ challengeId }: ChallengeDetailsRequest) => ({
        url: "",
        params: {
          Endpoint: "GetDetailsById",
          ChallengeId: challengeId,
          UserId: localStorageSecureWrapper.getItem("userId") || "",
        },
        method: "GET",
      }),
      providesTags: ["Challenges"],
      transformResponse: (response: ChallengeDetails) => response.result,
    }),
  }),
});

export const { useGetChallengeDetailsQuery } = GetChallengeDetailsQuery;
